'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    StrukturiertesPromotionsprogrammResource = _require2.StrukturiertesPromotionsprogrammResource;

module.exports.StrukturiertesPromotionsprogramm = function (_BaseEntity) {
  _inherits(StrukturiertesPromotionsprogramm, _BaseEntity);

  _createClass(StrukturiertesPromotionsprogramm, null, [{
    key: '__name__',
    value: function __name__() {
      return 'strukturiertespromotionsprogramm';
    }
  }]);

  function StrukturiertesPromotionsprogramm(data) {
    _classCallCheck(this, StrukturiertesPromotionsprogramm);

    var _this = _possibleConstructorReturn(this, (StrukturiertesPromotionsprogramm.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm)).call(this));

    _this._entityName = 'de.ul.fob.domain.StrukturiertesPromotionsprogramm';
    _this.beginn = null;
    _this.ende = null;
    _this.relevantFuerWeitere = false;
    _this.titel = null;

    _this.antragsteller = null;
    _this.beteiligteInstitutionen = null;
    _this.finanzierung = null;
    _this.organisationseinheit = null;
    _this.promProgTyp = null;
    _this.sprecher = null;
    _this.weitereOrganisationseinheiten = null;
    _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(StrukturiertesPromotionsprogramm, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'beginn', 'ende', 'relevantFuerWeitere', 'titel'],
        links: ['antragsteller', 'beteiligteInstitutionen', 'finanzierung', 'organisationseinheit', 'promProgTyp', 'sprecher', 'weitereOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchAntragsteller',
    value: function fetchAntragsteller() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'antragsteller');
    }
  }, {
    key: 'fetchBeteiligteInstitutionen',
    value: function fetchBeteiligteInstitutionen() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'beteiligteInstitutionen');
    }
  }, {
    key: 'fetchFinanzierung',
    value: function fetchFinanzierung() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'finanzierung');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPromProgTyp',
    value: function fetchPromProgTyp() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'promProgTyp');
    }
  }, {
    key: 'fetchSprecher',
    value: function fetchSprecher() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'sprecher');
    }
  }, {
    key: 'fetchWeitereOrganisationseinheiten',
    value: function fetchWeitereOrganisationseinheiten() {
      return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'antragsteller'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'beteiligteInstitutionen'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'finanzierung'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'promProgTyp'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'sprecher'), _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof StrukturiertesPromotionsprogrammResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(StrukturiertesPromotionsprogramm.prototype.__proto__ || Object.getPrototypeOf(StrukturiertesPromotionsprogramm.prototype), 'fetchQuery', this).call(this, StrukturiertesPromotionsprogrammResource);
      }
    }
  }]);

  return StrukturiertesPromotionsprogramm;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/strukturiertesPromotionsprogramm.js
// module id = 6yjd
// module chunks = 0